export const endpoints = Object.freeze({
    fileUpload: Object.freeze({
        uploadFragment: '/core/file-upload/upload-fragment',
        mergeFragments: '/core/file-upload/merge-fragments',
    }),
    fileRepository: Object.freeze({
        root: '/core/file-repository',
        rootFolders: '/core/file-repository/folders',
        rootFiles: '/core/file-repository/files',
        folder: (uid) => `/core/file-repository/folder/${uid}`,
        folderFolders: (uid) => `/core/file-repository/folder/${uid}/folders`,
        folderFiles: (uid) => `/core/file-repository/folder/${uid}/files`,
        file: (uid) => `/core/file-repository/file/${uid}`,
        fileContent: (uid) => `/core/file-repository/file/${uid}/content`,
        fileThumbnail: (uid) => `/core/file-repository/file/${uid}/thumbnail`,
    }),
});
